import { post } from '@webapp-next/lib/request/webapp/http';
import { WebappApiResponse } from '@/lib/types/request/request';
import { PayPeriod } from '@/modules/people/types/employment';
import { HelperEmptyObject } from '@/types';

export type PayPeriodsGetResponse = WebappApiResponse<PayPeriod[]>;

export default async function payPeriodsGet(
  offset = 0
): Promise<PayPeriodsGetResponse> {
  try {
    const { data } = await post<HelperEmptyObject, PayPeriodsGetResponse>(
      '/api/v1/resource/PayPeriod/QUERY',
      {
        sort: { Id: 'asc' },
        search: {
          s1: {
            field: 'Active',
            data: 1,
            type: 'eq',
          },
        },
        max: 500,
        start: offset,
      }
    );

    return {
      success: true,
      // TODO: we need to move this processing outside of API request layer
      // TODO: this could make the entire app behave erradicaly as it can potentially reach the API request concurrency limits and break the subsequent requests
      data:
        data.length === 500
          ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            [...data, ...(await payPeriodsGet(offset + 500))]
          : data,
      message: '',
      headers: {},
      meta: {},
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
